/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import BaseEditor, { ActionComposerEditorArgs } from 'cio/components/action-composer/base-glimmer/editor';

import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import LogModel from 'cio/models/log';
import { CreateEventPreview } from 'cio/utils/previews';
import DataActionRecipientCondition from 'cio/app-models/data-action/recipient-condition';
import AnalyticsService from 'cio/services/analytics';
import RouterService from '@ember/routing/router-service';
import { DataActionConditionType, DataActionTriggerAttributeDropdownItem } from 'cio/utils/campaigns/data-action';
import CustomerModel from 'cio/models/customer';
import BroadcastTriggerModel from 'cio/models/broadcast-trigger';
import DataActionBodyAttributeRows from 'cio/app-models/data-action/body-attribute-rows';
import EnvironmentService from 'cio/services/environment';
import ComposerEditableEntity from 'cio/utils/composer/composer-editable-entity';

interface CreateOrUpdatePersonEditorArgs extends ActionComposerEditorArgs {
  editableEntity: ComposerEditableEntity;
  supportedConditionTypes: DataActionConditionType[];
  selectedCustomer?: CustomerModel;
  selectedEvent?: LogModel;
  selectedTrigger?: BroadcastTriggerModel;
  preview: CreateEventPreview;
  recipientCondition: DataActionRecipientCondition;
  attributeUpdates: DataActionBodyAttributeRows;
  hasReadOnlyPermission: boolean;
  addBodyRow: () => unknown;
  removeBodyRow: (index: number) => unknown;
  updateHighlight: (highlight: DataActionTriggerAttributeDropdownItem | null) => unknown;
  previewDidChange?: () => unknown;
}

interface CreateOrUpdatePersonEditorSignature {
  Args: CreateOrUpdatePersonEditorArgs;
  Element: HTMLDivElement;
}

export default class CreateOrUpdatePersonEditor extends BaseEditor<CreateOrUpdatePersonEditorSignature> {
  @service analytics!: AnalyticsService;
  @service environment!: EnvironmentService;
  @service router!: RouterService;

  @action
  trackPreviewErrors(_: HTMLElement, [errors]: [{ field: string; label: string; errors: string[] }[]]) {
    if (this.args.isPreviewLoading) {
      return;
    }

    let messages = errors.map((e) => `${e.label}: ${e.errors.join(', ')}`);

    this.analytics.track('user', 'error_encountered', {
      currentUrl: this.router.currentURL,
      message: messages,
      source: 'Create or Update Person',
    });
  }
}
